import {Component, Input, OnInit} from '@angular/core';
import {CampaignDTO, CommercialDTO} from "../../services/api/api";

@Component({
  selector: 'sb-planning-status',
  templateUrl: './sb-planning-status.component.html',
  styleUrls: ['./sb-planning-status.component.scss'],
  standalone: false,
})
export class SbPlanningStatusComponent implements OnInit {
  @Input() booking: CampaignDTO | CommercialDTO;

  constructor() {}

  ngOnInit(): void {}
}
